export const TABLE_IDS = {
  CLIENT_ACCESS_KEYS: 'mo2wsof0uaqpq3f',
  BOOKINGS_HANDYMAN:  'm8gtnubj00q2shz',
  SERVICES_PRICING:   'm5ws0sid6kxibhk'
};

export const GATEWAY_BASE_URL = import.meta.env.VITE_GATEWAY_URL || 'https://api.portal.majormaker.org';

export async function gatewayFetch(endpoint, options = {}) {
  const token = localStorage.getItem('access_token');
  const headers = {
    'Content-Type': 'application/json',
    'X-App-ID': 'majormaker-booking-portal', // 👈 Application Identifier
    ...(token && { 'Authorization': `Bearer ${token}` }),
    ...options.headers
  };

  const response = await fetch(`${GATEWAY_BASE_URL}${endpoint}`, {
    ...options,
    headers
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    let message = errorData.detail;
    
    if (Array.isArray(message)) {
      message = message.map(e => `${e.loc ? e.loc.join('.') : 'field'}: ${e.msg}`).join(', ');
    } else if (typeof message === 'object') {
      message = JSON.stringify(message);
    }
    
    throw new Error(message || `Gateway error: ${response.status}`);
  }

  return response.json();
}